import type { RefObject } from "react"

export const getDialogOnOpenAutoFocusHandler = (contentRef: RefObject<HTMLDivElement | null>) => {
  return (e: Event) => {
    e.preventDefault()
    const content = contentRef.current

    // Set focus to the content element itself, not the Close button
    if (content) {
      content.focus()
    }
  }
}

export const getDialogOnInteractOutsideHandler = () => {
  return (e: Event) => {
    // Interacting with the toasts should not close the dialog
    if ((e.target as HTMLElement).closest("[data-sonner-toast]")) {
      e.preventDefault()
    }
  }
}
